import React from 'react';
import { withRouter } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import HeaderMenu, { isActive } from './HeaderMenu';

const SubMenu = ({ menus, location }) => {
  const theme = useTheme();

  const subMenus = (menus || []).reduce((found, menu) => {
    if (found.length) return found;
    const aliases = (menu.subMenus || []).map((sub) => sub.link);
    return isActive(aliases, location.pathname) ? menu.subMenus : found;
  }, []);

  if (!subMenus.length) return null;

  return (
    <Box
      padding="0px 24px"
      sx={{
        backgroundColor: theme.colorTokens.surfaceContainerHigh || '#f5f5f5',
      }}
      data-testid="header-submenu"
    >
      <HeaderMenu
        menus={subMenus}
        isParentMenu={false}
        activeBorderWidth={3}
        activeBorderColor={theme.palette.primary.main}
        style={{
          color: theme.palette?.text?.primary || '#333',
          fontWeight: 600,
        }}
      />
    </Box>
  );
};

export default withRouter(SubMenu);
